import { render, staticRenderFns } from "./CommunityUnitBusinessNewsDetail.vue?vue&type=template&id=d07f66ae&scoped=true"
import script from "./CommunityUnitBusinessNewsDetail.vue?vue&type=script&lang=js"
export * from "./CommunityUnitBusinessNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityUnitBusinessNewsDetail.vue?vue&type=style&index=0&id=d07f66ae&prod&scoped=true&lang=css"
import style1 from "./CommunityUnitBusinessNewsDetail.vue?vue&type=style&index=1&id=d07f66ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07f66ae",
  null
  
)

export default component.exports